import { httpClient } from '@/shared/api/httpClient';

export type VeiculoResumo = {
  id: string;
  clienteId: string;
  /** null em veículo cadastrado sem placa — mostre `descricao` na tela. */
  placa: string | null;
  /** Placa quando existe; senão "Marca Modelo Ano". Nunca vazio. */
  descricao: string;
  marca: string;
  modelo: string;
  ano: number | null;
  motor: string | null;
  kmAtual: number | null;
  /** true enquanto não foi confirmado pelo servidor. */
  syncPendente: boolean;
};

export type CadastrarVeiculoRequest = {
  clienteId: string;
  /** Vazio ou null cadastra o veículo sem placa (exige marca e modelo). */
  placa?: string | null;
  marca: string;
  modelo: string;
  ano?: number | null;
  motor?: string | null;
  kmAtual?: number | null;
};

export type CadastrarVeiculoResponse = {
  id: string;
  placa: string | null;
  transferiu: boolean;
};

export type OrcamentoDoVeiculo = {
  id: string;
  numero: string;
  data: string;
  status: string;
  total: number;
  clienteId: string;
  clienteNome: string | null;
  placa: string | null;
};

export type OrigemKm = 'Cadastro' | 'Orcamento' | 'Manual';

export type VeiculoKmRegistro = {
  id: string;
  veiculoId: string;
  km: number;
  data: string;
  origem: OrigemKm;
  orcamentoId: string | null;
  observacao: string | null;
};

export type RegistrarKmRequest = {
  km: number;
  data?: string | null;
  observacao?: string | null;
};

function querystring(params: Record<string, string | undefined>) {
  const usp = new URLSearchParams();
  for (const [k, v] of Object.entries(params)) {
    if (v !== undefined && v !== '') usp.set(k, v);
  }
  const s = usp.toString();
  return s === '' ? '' : `?${s}`;
}

export type ConsultaPlacaResposta = {
  placa: string;
  consultadoEm: string;
  origem: 'cache' | 'api';
  veiculo: {
    placa: string;
    marca: string;
    modelo: string;
    ano: string;
    chassi: string;
    motor: string;
    cor: string | null;
    anoModelo: string | null;
    municipio: string | null;
    uf: string | null;
  };
};

export type CadastrarPorPlacaRequest = {
  clienteId: string;
  placa: string;
  kmAtual?: number | null;
};

export type CadastrarPorPlacaResposta = {
  id: string;
  placa: string;
  origem: 'local' | 'cache' | 'api';
  transferiu: boolean;
  dadosConsulta?: ConsultaPlacaResposta;
};

export const veiculosApi = {
  /** Lista todos os veículos cadastrados (sem filtro de cliente). */
  listarTodos: () => httpClient.get<VeiculoResumo[]>('/api/veiculos'),
  listarPorCliente: (clienteId: string) =>
    httpClient.get<VeiculoResumo[]>(`/api/veiculos${querystring({ clienteId })}`),
  buscarPorPlaca: (placa: string) =>
    httpClient.get<VeiculoResumo[]>(`/api/veiculos${querystring({ placa })}`),
  cadastrar: (cmd: CadastrarVeiculoRequest) =>
    httpClient.post<CadastrarVeiculoResponse>('/api/veiculos', cmd),
  excluir: (id: string) => httpClient.delete<void>(`/api/veiculos/${id}`),
  historicoKm: (veiculoId: string) =>
    httpClient.get<VeiculoKmRegistro[]>(`/api/veiculos/${veiculoId}/km`),
  historicoOrcamentos: (veiculoId: string) =>
    httpClient.get<OrcamentoDoVeiculo[]>(`/api/veiculos/${veiculoId}/orcamentos`),
  registrarKm: (veiculoId: string, cmd: RegistrarKmRequest) =>
    httpClient.post<{ id: string }>(`/api/veiculos/${veiculoId}/km`, cmd),
  /**
   * Consulta a placa no servidor central. Resposta vem do cache global quando
   * disponível, evitando custo na wdapi2.com.br.
   */
  consultarPlaca: (placa: string) =>
    httpClient.get<ConsultaPlacaResposta>(`/api/placas/${encodeURIComponent(placa)}`),
  /**
   * Fluxo "cadastrar novo" automático: tenta o banco local; se não houver,
   * consulta a placa e cria o veículo já vinculado ao cliente.
   */
  cadastrarPorPlaca: (cmd: CadastrarPorPlacaRequest) =>
    httpClient.post<CadastrarPorPlacaResposta>('/api/veiculos/por-placa', cmd),
};
